import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../config";
import { Handshake, Loader2 } from "lucide-react";
import SiempriaCredit from "../components/SiempriaCredit";

export default function PartnerLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      if (data.user.role !== "partner") throw new Error("not_partner");
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_role", data.user.role);
      localStorage.setItem("admin_email", data.user.email);
      navigate("/partner");
    } catch {
      toast.error("Acceso de colaborador no válido");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-topacio-sand flex flex-col items-center justify-center px-6 py-10" data-testid="partner-login-page">
      <form onSubmit={submit} className="w-full max-w-sm card-brutal p-8">
        <div className="flex justify-center mb-8">
          <img src="/logo-topacio.jpg" alt="Rent a Moto Topacio" className="h-16 w-auto rounded-md border-2 border-topacio-ink shadow-[3px_3px_0_0_#111]" />
        </div>
        <div className="flex items-center justify-center gap-2 mb-6">
          <Handshake className="w-5 h-5 text-topacio-red" />
          <h1 className="font-display font-bold text-topacio-ink">Panel de colaboradores</h1>
        </div>
        <input data-testid="partner-email-input" type="email" required placeholder="Email" value={email}
          onChange={(e) => setEmail(e.target.value)} className="input-brutal" />
        <input data-testid="partner-password-input" type="password" required placeholder="Contraseña" value={password}
          onChange={(e) => setPassword(e.target.value)} className="input-brutal mt-4" />
        <button data-testid="partner-login-btn" disabled={busy} className="btn-primary w-full mt-6">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Entrar
        </button>
        <Link to="/partners" className="block text-center text-xs font-extrabold text-topacio-faded hover:text-topacio-ink transition-colors mt-4 underline underline-offset-2">
          Quiero ser colaborador
        </Link>
      </form>
      <SiempriaCredit />
    </div>
  );
}
